export function StringIsEmpty(str) {
    if (!str || !str.length) {
        return true
    }
    return false
}